import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

export class MenuButton extends Component {
    render() {
        return (
            <Button
                data-testid="menu-button"
                disabled={this.props.disabled}
                hidden={this.props.hidden}
                onClick={this.props.clickEvent}
            >
                <Text>{this.props.text}</Text>
                {this.props.icon}
            </Button>
        );
    }
}

const Button = styled.button`
    margin: 0 0 1em 3px;
    background: ${props => (props.disabled ? "#e4e4e4" : "#fff")};
    border: 1px solid #aaa;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px 10px;
    min-width: 100px;
    outline-color: ${props => props.theme.primary};
    outline-width: thin;
`;

const Text = styled.span`
    margin-right: 5px;
`;

MenuButton.propTypes = {
    clickEvent: PropTypes.func,
    className: PropTypes.string,
    text: PropTypes.string,
    disabled: PropTypes.bool,
    hidden: PropTypes.bool,
    icon: PropTypes.object
};
